import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import PaymentReminderStripe from "./PaymentReminderStripe";

const Layout = ({ children }) => {
  const [isMobileSideBarOpen, setIsMobileSideBarOpen] = useState(false);
  const [isMobileView, setIsMobileVew] = useState(false);
  const location = useLocation();
  const [enabledPaths] = useState(["/table-overview", "/order-parcel"]);
  const currentPath = location.pathname;

  const toggleSideBarOpen = () => {
    setIsMobileSideBarOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobileVew(window.innerWidth <= 768); // Corrected function name
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="md:flex-row flex-col flex">
      <Sidebar isOpen={isMobileSideBarOpen} toggleSidebar={toggleSideBarOpen} />
      <main className="flex-1 w-[100vw] md:w-[unset] h-[calc(100vh)]">
        {/* PAYMENT REMINDER STRIPE */}
        <PaymentReminderStripe
        />
        {(isMobileView || enabledPaths.includes(currentPath)) && (
          <Header toggleSidebar={toggleSideBarOpen} />
        )}
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
